/**
 * Events slider
 */
(function($) {
  "use strict";

  $(window).ready(slickify);

  // Constants
  var eventsSlider = ".view-liste-evenement > .view-content";


  /**
   * Init
   */
  function slickify() {

    $(eventsSlider).each(function(key,){
      $( this ).not('.slick-initialized').slick({
        slidesToShow: $( this ).parents('[data-number-slide]').data('number-slide'),
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });

   if($('.view-liste-evenement .slick-slide').length <= 4){
       $('.paragraph--type--evenement .slick-dots').hide();
   }

  }

})(jQuery);

